<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('coop_event_management')"
                        :isNewButton="true"
                        @new-button-click="showCreateModal"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_event_management')"
                              :isNewButton="true"
                              @new-button-click="showCreateModal"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="true"
                              @exportExcel="$refs.datatable.excel()">
                <b-row>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('coop_company')">
                            <b-form-select v-model="datatable.queryParams.filter.company_id" :options="companyOptions" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('coop_event_format')">
                            <b-form-select v-model="datatable.queryParams.filter.event_format" :options="eventFormatFilterOptions" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input v-model="datatable.queryParams.filter.date" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="datatable.queryParams.filter.status" :options="statusFilterOptions" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="datatable.queryParams.filter.academic_year" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="datatable.queryParams.filter.semester" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />

            <CommonModal ref="createModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('coop_event_new') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form v-if="showCreate" @actionSuccess="onActionSuccess" @cancel="createModal.hide()" />
                </template>
            </CommonModal>

            <CommonModal ref="statusModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('coop_update_status') }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-form-group :label="$t('status')">
                        <b-form-select v-model="selectedStatus" :options="statusOptions" />
                    </b-form-group>
                    <div class="d-flex justify-content-center mt-2">
                        <b-button variant="primary" @click="saveStatus">{{ $t('save') }}</b-button>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import AcademicYearsSelectbox from '@/components/interactive-fields/AcademicYearsSelectbox';
    import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox';

    //Page
    import CreateForm from './CreateForm';

    //Service
    import CoopEventService from '@/services/CoopEventService';
    import CoopCompanyService from '@/services/CoopCompanyService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            DatatableFilter,
            Datatable,
            CommonModal,
            AcademicYearsSelectbox,
            SemestersSelectbox,
            CreateForm
        },
        metaInfo() {
            return {
                title: this.$t('coop_event_management')
            };
        },
        data() {
            return {
                showCreate: false,
                selectedEventId: null,
                selectedStatus: null,
                companyOptions: [],
                statusOptions: [
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ],
                statusFilterOptions: [
                    {value: null, text: ''},
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ],
                eventFormatFilterOptions: [
                    {value: null, text: ''},
                    {value: 'online', text: this.$t('coop_location_type_remote')},
                    {value: 'onsite', text: this.$t('coop_location_type_onsite')},
                    {value: 'hybrid', text: this.$t('coop_location_type_hybrid')}
                ],
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('coop_update_status'),
                                    class: 'ri-refresh-line',
                                    callback: (row) => {
                                        this.showStatusModal(row);
                                    }
                                },
                                {
                                    text: this.$t('coop_event_view_applications'),
                                    class: 'ri-file-list-3-line',
                                    callback: (row) => {
                                        this.$router.push('/coop/admin/event/' + row.id + '/applications');
                                    }
                                },
                                {
                                    text: this.$t('coop_event_delete'),
                                    class: 'ri-delete-bin-2-line',
                                    callback: (row) => {
                                        this.deleteEvent(row);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('coop_event_name'),
                            field: 'event_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_event_type'),
                            field: 'event_type',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_company'),
                            field: 'company_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('date'),
                            field: 'date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_event_time'),
                            field: 'time',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_event_format'),
                            field: 'event_format',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_quota'),
                            field: 'quota',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            formatFn: (status) => {
                                return status === 'active' ? this.$t('active') : this.$t('passive');
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        created() {
            this.getRows();
            CoopCompanyService.getAll({params: {filter: {}, page: 1, limit: 1000}}).then((response) => {
                this.companyOptions = [{value: null, text: ''}].concat(
                    response.data.data.map((c) => ({value: c.id, text: c.name}))
                );
            });
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {...this.datatable.queryParams},
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CoopEventService.getAll(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination.total;
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            showCreateModal() {
                this.showCreate = true;
                this.$refs.createModal.$refs.commonModal.show();
            },
            formClear() {
                this.showCreate = false;
            },
            onActionSuccess() {
                this.$refs.createModal.$refs.commonModal.hide();
                this.showCreate = false;
                this.getRows();
            },
            showStatusModal(row) {
                this.selectedEventId = row.id;
                this.selectedStatus = row.status;
                this.$refs.statusModal.$refs.commonModal.show();
            },
            saveStatus() {
                CoopEventService.updateStatus(this.selectedEventId, this.selectedStatus).then(() => {
                    this.$toast.success(this.$t('coop_status_updated_success'));
                    this.$refs.statusModal.$refs.commonModal.hide();
                    this.getRows();
                });
            },
            deleteEvent(row) {
                this.$swal.fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then((result) => {
                    if (result.isConfirmed) {
                        CoopEventService.remove(row.id).then(() => {
                            this.$toast.success(this.$t('coop_event_deleted_success'));
                            this.getRows();
                        });
                    }
                });
            }
        }
    };
</script>
